import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { getAllProductChannels } from "store/channels/actions"
import { updateJackpot } from "store/jackpots/actions"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import React, { useEffect, useState } from "react"
import Select from "react-select"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import MetaTags from "react-meta-tags"
import {
    Table,
    InputGroup,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    Button,
    Card,
    Input,
    CardBody,
    Col,
    Container,
    Form,
    Label,
    Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import {
    dateIsBetween,
    formValidation,
    mapDataForDropDown,
    showErrorMessages,
} from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import {getAllJackpotsCall, getAllEventsCall, getAllSportsCall, getFixtureBySportIdCall} from "helpers/repository"
import { getAllEvents } from "store/events/actions"
import moment from "moment";
import {sitename} from "../../../constants/constants";
const View = props => {
    const outerData = [];
    const outerDataSelected = [];
    const Channels = useSelector(state => state.productChannels.Index ?? [])
    const Events = useSelector(state => state.events.Index ?? [])

    const dispatch = useDispatch()
    const [name, set_name] = useState("")
    const [description, set_description] = useState("")
    const [market, set_market] = useState("")
    const [is_active, set_is_active] = useState("")
    const [price_per_ticket, set_price_per_ticket] = useState("")
    const [max_price, set_max_price] = useState("")
    const [n_1, set_n_1] = useState("")
    const [n_2, set_n_2] = useState("")
    const [channels, set_channels] = useState([])
    const [events, set_events] = useState([])
    const [selected_events, set_selected_events] = useState([])
    const [sportId, setSportId] = useState(null);
    const [fixtures, setFixtureData] = useState([]);
    const [leagues, setLeagues] = useState([]);
    const [selectedDates, setSelectedDates] = useState([moment().add(1, 'days').format("YYYY-MM-DD"),moment().add(1, 'days').format("YYYY-MM-DD")])

    const urlParams = new URLSearchParams(props.location.search)

    useEffect(() => {
        dispatch(apiError(""))
        dispatch(getAllProductChannels())
        dispatch(getAllEvents())
        setSelectedDates([moment().add(1, 'days').format("YYYY-MM-DD"),moment().add(1, 'days').format("YYYY-MM-DD")])
        getData(moment().subtract(5, 'days').format("YYYY-MM-DD"),moment().subtract(5, 'days').format("YYYY-MM-DD"))
        getAllJackpotsCall().then(res => {
            let obj = res.data.data.filter(bn => bn["id"] == urlParams.get("id"))
            obj = obj.length > 0 ? obj[0] : {}
            let allLeagues = obj.fixtures?.map((f) => f?.tournament?.bb_id);
            allLeagues = [...new Set(allLeagues)];
            allLeagues?.map((league, index) => {
                obj.fixtures
                    .filter((f) => f.tournament_bb_id == league)
                    .map((fixture) => {
                        const innerData={};
                        innerData['id']=fixture.bb_id;
                        innerData['team_1']=fixture.competitors[0]?.name;
                        innerData['team_2']=fixture.competitors[1]?.name;
                        innerData['date']=new Date(parseInt(fixture.match_date.$date.$numberLong)).toLocaleString('en-GB')
                        outerDataSelected.push(innerData);
                    })
            })
            set_selected_events(outerDataSelected);

            // getAllEventsCall().then(res => {
            //   const myDifferences = _.differenceBy(res.data.data, obj.events, "id")
            //   set_events(myDifferences)
            //   set_selected_events(obj.events)
            // })

            let sl_events = [...obj.fixtures]
            sl_events.forEach(function (v) {
                delete v.pivot
            })

            set_name(obj.name)
            set_description(obj.description)
            set_market(obj.market)
            set_is_active(obj.is_active)
            set_price_per_ticket(obj.price_per_ticket)
            set_max_price(obj.max_price)
            set_n_1(obj.n_1)
            set_n_2(obj.n_2)
            set_channels(mapDataForDropDown(obj.channels))
        })
    }, [])

    useEffect(() => {
        if(fixtures){
            let allLeagues = fixtures?.map((f) => f?.tournament?.bb_id);
            allLeagues = [...new Set(allLeagues)];
            setLeagues(allLeagues);
        }
    }, [fixtures]);

    useEffect(() => {
        if(leagues){
            leagues?.map((league, index) => {

                fixtures
                    .filter((f) => f.tournament_bb_id == league)
                    .map((fixture) => {
                        const innerData={};
                        innerData['id']=fixture.bb_id;
                        innerData['team_1']=fixture.competitors[0]?.name;
                        innerData['team_2']=fixture.competitors[1]?.name;
                        innerData['date']=new Date(parseInt(fixture.match_date.$date.$numberLong)).toLocaleString('en-GB')
                        outerData.push(innerData);
                    })
            })
            set_events(outerData);

        }
    }, [leagues]);

    const getData = (date1,date2,marketVal=null) => {
        getAllSportsCall().then(res => {
            const sports=res.data.data.data
            if(sports){
                setSportId(sports?.find((s) => s.name == "Soccer")?.id);
                const sporsID=sports?.find((s) => s.name == "Soccer")?.id;
                var marketData=marketVal==null?market:marketVal;
                getFixtureBySportIdCall(sporsID,date1,date2,marketData)
                    .then((res) => {
                        const myDifferences = _.differenceWith(res.data.data, selected_events, ({ bb_id }, { id }) => _.eq(bb_id, id))
                        setFixtureData(myDifferences);
                    });
            }
        })
    }
    const formErrors = useSelector(state => state?.CommonState)

    const handleSubmit = e => {
        e.preventDefault()
        const data = {
            name: name,
            description: description,
            market: market,
            price_per_ticket: price_per_ticket,
            max_price: max_price,
            is_active: is_active,
            n_1: n_1,
            n_2: n_2,
            is_active,
            product_channel_id: channels.map(item => item.id),
            event_id: selected_events.map(se => se.id),
            id: urlParams.get("id"),
        }
        if (data.event_id.length == 0) {
            toastr.error("Please Select an Event")
        }
        dispatch(updateJackpot(data, props.history))
    }
    const removeError = key => {
        let e = _.cloneDeep(formErrors)
        delete e[key]
        dispatch(apiError(e))
    }

    const selectedColumns = [
        {
            dataField: "team_1",
            text: "Name",
            sort: true,
            style: { whiteSpace: "break-spaces" },
            formatter: (cellContent, row) => (
                <>
                    <p className="mb-1 fw-bold">{`${row.date} ${row.team_1} vs ${row.team_2}`}</p>
                </>
            ),
        },

    ]
    const defaultSorted = [
        {
            order: "asc",
        },
    ]

    // Table Data
    const pageOptions = {
        sizePerPage: 10,
        totalSize: Events.length, // replace later with size(customers),
        custom: true,
    }

    const { SearchBar } = Search

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{sitename}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Bonuses" breadcrumbItem="View" />
                    <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-sort-up"></i> &nbsp; View Jackpot Pool
                        </h5>
                        <CardBody>

                            <div className="row mb-4">
                                <div className="col">
                                    <label className="form-label">Name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        onChange={e => {
                                            removeError("name")
                                            set_name(e.target.value)
                                        }}
                                        readOnly
                                        value={name}
                                    />
                                    {formErrors?.name ? (
                                        <FieldValidation errorMessage={formErrors?.name} />
                                    ) : null}
                                </div>
                                <div className="col">
                                    <label className="form-label">Description</label>
                                    <input
                                        readOnly
                                        className="form-control"
                                        type="text"
                                        onChange={e => {
                                            removeError("description")
                                            set_description(e.target.value)
                                        }}
                                        value={description}
                                    />
                                    {formErrors?.description ? (
                                        <FieldValidation errorMessage={formErrors?.description} />
                                    ) : null}
                                </div>
                                <div className="col">
                                    <label className="form-label">Market</label>
                                    <input
                                        readOnly
                                        className="form-control"
                                        type="text"

                                        value={market}
                                    />
                                </div>
                                <div className="col">
                                    <label className="form-label">Channels</label>
                                    <Select
                                        disabled
                                        readonly
                                        maxMenuHeight={150}
                                        isMulti={true}
                                        options={mapDataForDropDown(Channels)}
                                        classNamePrefix="select2-selection"
                                        value={channels}
                                    />
                                </div>

                            </div>
                            <div className="row mb-4">
                                <Col lg={2}>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Is Active?</label>
                                            <div className="row mb-4">
                                                <Col lg={12}>
                                                    <input
                                                        readOnly
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value=""
                                                        id="defaultCheck1"
                                                        checked={is_active}
                                                    />{" "}
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="defaultCheck1"
                                                    >
                                                        activate pool
                                                    </label>
                                                    {formErrors?.is_active ? (
                                                        <FieldValidation
                                                            errorMessage={formErrors?.is_active}
                                                        />
                                                    ) : null}
                                                </Col>
                                            </div>
                                        </Col>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Price</label>
                                            <InputGroup>
                                                <div className="input-group-text">Per Ticket</div>
                                                <input
                                                    readOnly
                                                    type="text"
                                                    className="form-control"
                                                    id="autoSizingInputGroup"
                                                    value={price_per_ticket}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </div>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Prizes (Max)</label>
                                            <InputGroup>
                                                <div className="input-group-text">5 Hit</div>
                                                <input
                                                    readOnly
                                                    type="text"
                                                    className="form-control"
                                                    id="autoSizingInputGroup"
                                                    onChange={e => {
                                                        removeError("max_price")
                                                        set_max_price(e.target.value)
                                                    }}
                                                    value={max_price}
                                                />
                                            </InputGroup>

                                        </Col>
                                    </div>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Prizes (N - 1)</label>
                                            <InputGroup>
                                                <div className="input-group-text">5 Hit</div>
                                                <input
                                                    readOnly
                                                    type="text"
                                                    className="form-control"
                                                    id="autoSizingInputGroup"
                                                    onChange={e => {
                                                        removeError("n_1")
                                                        set_n_1(e.target.value)
                                                    }}
                                                    value={n_1}
                                                />
                                            </InputGroup>

                                        </Col>
                                    </div>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Prizes (N - 2)</label>
                                            <InputGroup>
                                                <div className="input-group-text">5 Hit</div>
                                                <input
                                                    readOnly
                                                    type="text"
                                                    className="form-control"
                                                    id="autoSizingInputGroup"
                                                    onChange={e => {
                                                        removeError("n_2")
                                                        set_n_2(e.target.value)
                                                    }}
                                                    value={n_2}
                                                />
                                            </InputGroup>

                                        </Col>
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="row mb-4">
                                        <Col lg={12}>
                                            <label className="form-label">Selected Events</label>
                                            <Card>
                                                <CardBody>
                                                    <ToolkitProvider
                                                        keyField="id"
                                                        columns={selectedColumns}
                                                        data={selected_events}
                                                        search
                                                    >
                                                        {toolkitProps => (
                                                            <React.Fragment>
                                                                <Row className="mb-2">
                                                                    <Col lg="12">
                                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                                            <div className="position-relative">
                                                                                <SearchBar
                                                                                    {...toolkitProps.searchProps}
                                                                                />
                                                                                <i className="bx bx-search-alt search-icon" />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col xl="12">
                                                                        <div
                                                                            className="table-responsive"
                                                                            style={{
                                                                                height: 400,
                                                                                overflowY: "auto",
                                                                            }}
                                                                        >
                                                                            <BootstrapTable
                                                                                keyField={"id"}
                                                                                responsive
                                                                                bordered={false}
                                                                                striped={false}
                                                                                defaultSorted={defaultSorted}
                                                                                classes={
                                                                                    "table align-middle table-nowrap"
                                                                                }
                                                                                headerWrapperClasses={"thead-light"}
                                                                                {...toolkitProps.baseProps}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        )}
                                                    </ToolkitProvider>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </div>
                                </Col>
                            </div>

                            <div className="d-flex flex-wrap gap-2 justify-content-end">
                                {/*<Button type="submit" color="primary">*/}
                                {/*    Save*/}
                                {/*</Button>*/}
                                <Button
                                    type="reset"
                                    color="secondary"
                                    className=""
                                    onClick={() => {
                                        props.history.push("/promotions/jackpots")
                                    }}
                                >
                                    Back
                                </Button>
                            </div>

                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}
export const ViewJackpot = withRouter(View)
